import Client from 'requests/client';

const client = new Client({
  basePath: '/users/sign_in',
  dataType: false,
  headers: {
    'No-Turbo-Redirect': true,
  },
});

export const signInRequest = async data => {
  return client.create({ data });
};
